var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-binoculars"}),_vm._v(" Lọc Dữ Liệu\n")])}
var staticRenderFns = []

export { render, staticRenderFns }